import { ErrorMessage, Field, Form, Formik } from "formik"
import parsePhoneNumber, { validatePhoneNumberLength } from "libphonenumber-js"

import classNames from "@src/utilities/class-names"

import type { FocusEvent } from "react"

interface CheckoutPhoneFormProps {
  initialPhoneNumber: string
  onFormChanged: (phoneNumber: string) => void
}
export default function CheckoutPhoneForm({
  initialPhoneNumber,
  onFormChanged,
}: CheckoutPhoneFormProps) {
  return (
    <Formik
      initialValues={{
        phoneNumber: initialPhoneNumber,
      }}
      onSubmit={async (values, { setSubmitting }) => {
        onFormChanged(values.phoneNumber)
        setSubmitting(false)
      }}
    >
      {({ errors, touched, handleBlur, handleSubmit, setFieldValue }) => (
        <Form
          className="max-w-md"
          onChange={(ev) => {
            handleSubmit(ev)
          }}
          onSubmit={(ev) => {
            ev.preventDefault()
            handleSubmit(ev)
          }}
        >
          <h2 className="font-browser font-medium text-lg">
            <span className="text-sm text-gray-600">(Optional)</span> Text
            Updates
          </h2>
          <p className="font-browser text-sm">
            Enter your phone number to receive text updates about your order and
            other information from Onyx + Rose. Unsubscribe at any time.
          </p>
          <div className="mt-2">
            <Field
              autoComplete="phone-number"
              className={classNames(
                "p-2 relative block w-full rounded-sm bg-transparent focus:z-10 border border-gray-400",
                errors.phoneNumber && touched.phoneNumber ? "text-red" : ""
              )}
              id="phoneNumber"
              onBlur={(ev: FocusEvent<HTMLInputElement>) => {
                try {
                  const phoneParsed = parsePhoneNumber(ev.target.value, "US")
                  if (phoneParsed?.isValid()) {
                    setFieldValue("phoneNumber", phoneParsed.formatNational())
                  }
                } catch (_) {
                  //
                }
                handleBlur(ev)
              }}
              validate={(value: string): string | undefined => {
                try {
                  const phoneParsed = parsePhoneNumber(value, "US")
                  if (
                    value.trim() === "" ||
                    phoneParsed?.isValid() ||
                    validatePhoneNumberLength(value, "US") === "TOO_SHORT"
                  ) {
                    return undefined
                  }
                } catch (_) {
                  //
                }
                return "Invalid phone number"
              }}
              placeholder="Phone number"
              type="text"
              name="phoneNumber"
            />
            <ErrorMessage
              name="phoneNumber"
              component="span"
              className="absolute pointer-events-none font-medium text-xs text-red z-20 top-1 right-2"
            />
          </div>
          <p className="mt-2 text-xs text-gray-900">
            Regular carrier rates apply.
          </p>
        </Form>
      )}
    </Formik>
  )
}
